<template>
  <!-- tab 3-->
  <v-tab-item key="3">
    <v-card flat class="px-6">
      <v-row align="center" mt-4>
        <v-col md="3">
          <span>New password:</span>
        </v-col>
        <v-col
          md="9"
          class="text-left"
          :class="{ 'show-password': passwordChanged }"
        >
          <v-btn
            v-if="!passwordChanged"
            tile
            class="white--text filled-btn"
            color="#58E2C2"
            :disabled="passwordLoader"
            :data-test-id="`${dataTestId}__generate-password-btn`"
            @click="generatePassword"
          >
            {{ passwordBtnText }}
          </v-btn>
          <label
            v-if="passwordChanged"
            :data-test-id="`${dataTestId}__generated-password-text`"
          >
            {{ generatedPassword }}
          </label>
        </v-col>
      </v-row>
      <v-row align="center" mt-4 v-if="passwordChanged">
        <v-col md="3"></v-col>
        <v-col md="9" class="text-left pl-0">{{
          $message.PASSWORD_CARE_HANDLE
        }}</v-col>
      </v-row>
    </v-card>
  </v-tab-item>
  <!-- tab 3-->
</template>
<script>
import UserService from '../../../services/UserService';
export default {
  data() {
    return {
      passwordLoader: false,
      passwordChanged: false,
      generatedPassword: '',
      passwordBtnText: 'Generate Password',
    };
  },
  props: {
    userId: String,
    dataTestId: String
  },
  methods: {
    // generate new password
    async generatePassword() {
      this.generatedPassword = '';
      this.passwordLoader = true;
      this.passwordBtnText = 'Generating...';
      this.passwordChanged = false;
      try {
        let passwordResponse = await UserService.generatePassword(
          this.userId
        );
        if (passwordResponse.data.success) {
          this.passwordChanged = true;
          this.passwordLoader = false;
          this.passwordBtnText = 'Generate Password';
          this.generatedPassword = passwordResponse.data.body;
        } else {
          this.snackbar('error', this.$message.CANNOT_CHANGE_PASSWORD);
          this.passwordLoader = false;
          this.passwordBtnText = 'Generate Password';
        }
      } catch (err) {
        this.snackbar('error', err);
        this.passwordLoader = false;
        this.passwordBtnText = 'Generate Password';
      }
    },
  },
};
</script>
